module.exports = __webpack_public_path__ + "static/img/index_banner1.9db0723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_banner1.png
// module id = PtWI
// module chunks = 14